export const getAssignList = (payload?: any) => ({
    type: "@saga/GET_ASSIGN_LIST",
    payload
});